import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import {
  branch,
  compose,
  getContext,
  renderNothing,
  withProps,
  lifecycle
} from 'recompose'
import { injectIntl } from 'react-intl'
import { get } from 'lodash'
import {
  selectRefiStatus,
  selectFullLoanTotal
} from 'src/store/selectors/home/interest'
import { selectCorporateProfile } from 'src/store/selectors/customerProfile'
import { selectHasRecentLoan } from 'src/store/selectors/home'
import { selectCurrentCELs } from 'src/store/selectors/home/loans'
import {
  withAdditionalInfoToggle,
  withElementRef,
  scrollToRefOnMount
} from 'src/composables'
import { RefiSection } from 'src/constants/notificationRefs'
import { sampleLoan } from 'src/constants/homePreview'
import { getCurrentHash } from 'src/helpers/browser'

const contextTypes = {
  withCurrentHomeData: PropTypes.bool,
  locked: PropTypes.bool
}

const composeWithHomeData = compose(
  connect(state => {
    const profile = selectCorporateProfile(state)

    return {
      loans: selectCurrentCELs(state),
      refiStatus: selectRefiStatus(state),
      interestTotal: selectFullLoanTotal(state),
      companyName: get(profile, 'name'),
      rates: get(profile, 'rates', []),
      hasRecentLoan: selectHasRecentLoan(state)
    }
  }),
  branch(({ hasRecentLoan }) => true, renderNothing),
  withElementRef(RefiSection),
  scrollToRefOnMount
)

const composeWithoutHomeData = compose(
  withProps(() => ({
    loans: [sampleLoan],
    refiStatus: {
      15: true,
      25: true,
      30: true
    },
    interestTotal: get(sampleLoan, 'facts.totalInterest'),
    companyName: '1EG Mortgage',
    rates: [],
    hasRecentLoan: false
  }))
)

const RefinanceContainer = compose(
  getContext(contextTypes),
  branch(
    ({ withCurrentHomeData }) => withCurrentHomeData,
    composeWithHomeData,
    composeWithoutHomeData
  ),
  withAdditionalInfoToggle,
  lifecycle({
    componentDidMount () {
      if (getCurrentHash() === `#${RefiSection}`) {
        this.props.toggleInfo()
      }
    }
  }),
  injectIntl
)

export default RefinanceContainer
